var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-0 my-0"},[_c('div',[_c('router-link',{style:({'color':'inherit','display': 'flex','justify-content':'space-between','align-item':'center','text-decoration': 'none'}),attrs:{"to":'/reports/generatedReports'}}),_c('GenerateReportPage'),_c('v-divider')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }